import { SettingLanguagesScreenContainer } from "src/containers";

export const SettingLanguagesScreen = () => <SettingLanguagesScreenContainer />;
